import  { useState } from 'react';

export const useNotificationContext = () => {
    const [notificationCount, setNotificationCount] = useState<number>(0);
    
    return { 
        notificationCount,
        setNotificationCount,
    }

}